(function () {
  const root = (window.Douxcou = window.Douxcou || {});
  const routes = window.routes || { cart_add_url: "/cart/add", cart_change_url: "/cart/change", cart_url: "/cart", root_url: "/" };

  function cartSectionIds() {
    const ids = new Set(["cart-icon-bubble"]);
    document.querySelectorAll("[data-cart-section]").forEach((el) => ids.add(el.dataset.cartSection));
    return [...ids].slice(0, 5);
  }

  function renderSections(sections) {
    if (!sections) return;
    const parser = new DOMParser();
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const doc = parser.parseFromString(html, "text/html");
      document.querySelectorAll(`[data-cart-section="${id}"]`).forEach((target) => {
        const source = doc.querySelector(`[data-cart-section="${id}"]`);
        if (source) target.innerHTML = source.innerHTML;
      });
      if (id === "cart-icon-bubble") {
        const source = doc.querySelector("#cart-icon-bubble");
        document.querySelectorAll("#cart-icon-bubble").forEach((t) => source && (t.innerHTML = source.innerHTML));
      }
    });
  }

  async function post(url, body) {
    const res = await fetch(`${url}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ ...body, sections: cartSectionIds(), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || "Erreur panier");
    return data;
  }

  async function refreshCart(sections) {
    renderSections(sections);
    const cart = await fetch(`${routes.cart_url}.js`, { headers: { Accept: "application/json" } }).then((r) => r.json());
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: cart }));
    return cart;
  }

  root.cart = {
    async add(items, { openDrawer = true } = {}) {
      const data = await post(routes.cart_add_url, { items });
      const cart = await refreshCart(data.sections);
      if (openDrawer) root.drawer.open();
      return cart;
    },
    async change(line, quantity) {
      const data = await post(routes.cart_change_url, { id: line, quantity });
      return refreshCart(data.sections);
    },
    get: () => fetch(`${routes.cart_url}.js`).then((r) => r.json()),
  };

  root.drawer = {
    open() {
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));
    },
    close() {
      document.dispatchEvent(new CustomEvent("cart-drawer:close"));
    },
  };

  root.search = {
    open() {
      document.dispatchEvent(new CustomEvent("search:open"));
    },
    close() {
      document.dispatchEvent(new CustomEvent("search:close"));
    },
  };

  root.formatMoney = function (cents) {
    const format = window.moneyFormat || "{{amount_with_comma_separator}} €";
    const value = (Number(cents) / 100).toFixed(2);
    const [int, dec] = value.split(".");
    const withSep = (sep, decSep) => int.replace(/\B(?=(\d{3})+(?!\d))/g, sep) + decSep + dec;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, kind) => {
      switch (kind) {
        case "amount_with_comma_separator":
          return withSep(".", ",");
        case "amount_no_decimals_with_comma_separator":
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        case "amount_no_decimals":
          return int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        case "amount_with_space_separator":
          return withSep(" ", ",");
        default:
          return withSep(",", ".");
      }
    });
  };

  root.lockScroll = (locked) => document.body.classList.toggle("overflow-hidden", locked);

  document.documentElement.classList.replace("no-js", "js");
})();
